import { render } from "./SessionAudioVideoLinkModal.vue?vue&type=template&id=65bf5bfc&scoped=true"
import script from "./SessionAudioVideoLinkModal.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./SessionAudioVideoLinkModal.vue?vue&type=script&charset=utf-8&lang=js"

import "./SessionAudioVideoLinkModal.vue?vue&type=style&index=0&id=65bf5bfc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65bf5bfc"]])

export default __exports__